<template>
  <div :class="`main ${toatal.number > 0 && carts && carts.length > 0  ? 'show-cart' : 'hide-cart'}`" id="cart-bar">
    <div :class="`cart`">
      <div class='row con'>
        <div style="padding-top:8px;" class="col-md-5">
          <p style="margin:0;"><i class="fas fa-shopping-basket"></i> มีสินค้าในตะกร้าทั้งหมด {{toatal.number}} รายการ</p>
        </div>
        <div class="col-md-7 d-inline con2">
          <p class="d-inline">รวมค่าสินค้า : </p>
          <h3 class="price d-inline">฿{{eArabic(toatal.price)}}</h3>
          <button type="button" :class="`btn-main ${toatal.number <= 0 ? 'non-active' : ''} d-inline buy`" @click="cartPurchase()">สั่งซื้อสินค้า</button>
          <!-- <button type="button" :class="`btn-main ${!true ? 'non-active' : ''} d-inline remove`"  @click="initDataCart()"><i class="far fa-trash-alt"></i></button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import  store  from "../store"
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dataCarts: []
    }
  },
  mounted(){
    this.initDataCart()
  },
  methods: {
    cartPurchase() {
      if(!this.user){
        $('#modalLogin').modal('show')
        store.commit('setPurchasingType', 'cart')
      }else{
        store.commit('setFromBuyNow',false)
        $("#main-cid-detail").addClass("modal-open");
        $("#modal-purchase").removeClass("modal-purchase-hide");
        $("body").css({"overflow-y":"hidden"})
        
        $("#cart-bar").addClass("hide-cart");
        $("#cart-bar").removeClass("show-cart");
        store.commit('cartToPurchasing', this.dataCarts)

        if(this.user) this.$mixpanel.track(`click-purchase-stap1`, {products: this.purchasingProduct.map(p=>{return p.id}) , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName') , apartmentId: this.$route.query.apartmentId , from: "cart"})
        else this.$mixpanel.track(`click-purchase-stap1`, {products: this.purchasingProduct.map(p=>{return p.id}) , from: "cart"})
      }
    },
    async initDataCart(){
      try{
        let hashProducts = {}

        for(let p of this.allProduct){
          hashProducts[p.id] = p
        }

        this.dataCarts = []

        if(localStorage.getItem('carts')){
          let localCarts = JSON.parse(localStorage.getItem('carts'))
          let balanceStore
          if(!this.hashBalanceProduct || this.hashBalanceProduct.length < 1){
            balanceStore = await this.Parse.Cloud.run("MarketProduct_countBalanceStores",{products: localCarts.map(item => {return item.productId})});
            store.commit('setHashBalanceProduct', balanceStore)
          }
          if(!this.carts)
            store.commit('setCarts', localCarts)

          for(let cart of this.carts){
            let obj = {
              number: cart.number,
              id: cart.productId,
              name : hashProducts[cart.productId].get('name'),
              image : hashProducts[cart.productId].get('images') ? hashProducts[cart.productId].get('images')[0].url() : "",
              fullPrice : hashProducts[cart.productId].get('fullPrice'),
              price: hashProducts[cart.productId].get('price'),
              isIncludeVat : hashProducts[cart.productId].get('isIncludeVat'),
              delivery : hashProducts[cart.productId].get('delivery') || 0,
              deliveryPerNumber : hashProducts[cart.productId].get('deliveryPerNumber') || 0,
              deliveryCategory : hashProducts[cart.productId].get('deliveryCategory'),
              productList : hashProducts[cart.productId].get('productList') || [] , 
              discount : hashProducts[cart.productId].get('discount') || {},
              balanceProduct: this.hashBalanceProduct[cart.productId].balanceProduct
            }
            this.dataCarts.push(obj)
          }
        }
      }catch(e){
        localStorage.removeItem('carts')
      }
    },
    updateCart(){

    },
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
  },
  computed: {
    ...mapState([
      'purchasingProduct',
      'user',
      'allProduct',
      'carts',
      'hashBalanceProduct'
    ]),
    toatal() {
      let toatal = {
        number: 0,
        price: 0
      }
      if (this.dataCarts && this.dataCarts.length > 0) {
        for (let product of this.dataCarts) {
          toatal.number += product.number
          toatal.price += product.price * product.number
        }
      }
      return toatal
    }
  },
  watch: {
    allProduct(){
      this.initDataCart()
    },
    carts(){
      this.initDataCart()
    }
  },
};
</script>
<style scoped>
.main{
  position: fixed;
  bottom: 0;
  z-index: 2;
  background-color: rgb(243, 243, 243);
  border-top: 1px solid rgba(105, 105, 105, 0.5);
  width: 100%;
}
.cart{
  /* border: 1px solid black; */
  max-width: 1200px;
  margin: auto;
  padding: 3px 10px;
}
.price{
  display: inline;
  position: relative;
  top: 4px;
  font-weight: bold;
  color: #e9773b;
  margin-right: 10px;
}

p{
  margin: 0;
  display: inline;
}

.btn-main {
  margin: 0 1px;
  padding: 5px 10px;
  background: #e9773b;
  color:white;
  border: 1px solid white;
  transition: all .3s;
  font-weight: 200;
  border-radius: 10px;
}
.btn-main.buy{
  width: 200px;
}
.btn-main.remove{
  width: 50px;
}
.btn-main.non-active {
  pointer-events: none;
  cursor: default;
  color: rgb(170, 170, 170);
  border: 1px solid rgb(170, 170, 170);
  background-color: white;
}

.btn-main:hover {
  background:  white;
  color: #e9773b;
  border: 1px solid #e9773b;
}

.btn-main:focus {
  outline: unset;
}
.show-cart{
  display: block;
  opacity: 0;
  bottom: -20px;
  animation-duration: .2s;
  animation-name: show-cart;
  animation-fill-mode: forwards;
}
@keyframes show-cart {
  to {
      opacity: 1;
      bottom: 0;
  };
}
.hide-cart{
  display: block;
  animation-duration: .2s;
  animation-name: hide-cart;
  animation-fill-mode: forwards;
}
@keyframes hide-cart {
  to {
      opacity: 0;
      bottom: -20px;
  };
}
.con2{
  text-align: right;
}
@media only screen and (max-width: 768px) {
  .con{
    text-align: center;
  }
  .con2{
    text-align: center;
  }
  .btn-main.buy{
    width: 100%;
    margin-top: 8px;
  }
  .btn-main.remove{
    width: 100%;
  }
}
</style>